<script lang="ts" setup>
import { TaskParametersForm, TaskParameterTypeEnum } from "@/components";
import { computed, ref } from "vue";
import { useRouter } from "vue-router";

/**Маршруты */
const router = useRouter();

/**Компонент формы для настройки параметров */
const $taskParametersForm = ref<InstanceType<typeof TaskParametersForm>>();
/**Id проекта */
const projectId = computed(() => Number(router.currentRoute.value?.params.projectId));

/**Проверка наличия изменений в форме перед переходом */
router.beforeEach((to, from, next) => {
  if ($taskParametersForm.value?.haveChanges) {
    $taskParametersForm.value?.openLeaveConfirmation(() => {
      next();
    });
  } else {
    next();
  }
});
</script>
<template>
  <TaskParametersForm
    ref="$taskParametersForm"
    separate-templates
    :type="TaskParameterTypeEnum.Tag"
    :entity-id="projectId"
  />
</template>
